import { useState } from 'react'
import { Filter, Search, X } from 'lucide-react'
import { PessoaFilters } from '../tipos/pessoa'

interface PessoaFiltersProps {
  onSearch: (filters: PessoaFilters) => void
}

export function PessoaFiltersComponent({ onSearch }: PessoaFiltersProps) {
  const [filters, setFilters] = useState<PessoaFilters>({
    search: '',
    ativo: 'todos',
    cargoCodigo: 'todos',
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    onSearch(filters)
  }

  const handleClear = () => {
    const clearedFilters: PessoaFilters = {
      search: '',
      ativo: 'todos',
      cargoCodigo: 'todos',
    }
    setFilters(clearedFilters)
    onSearch(clearedFilters)
  }

  const handleInputChange = (field: keyof PessoaFilters, value: any) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }))
  }

  return (
    <div className="bg-white rounded-xl p-6 border border-gray-200 shadow-theme-sm mb-6">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-gradient-to-r from-brand-500 to-brand-600 rounded-lg flex items-center justify-center">
            <Filter className="w-5 h-5 text-white" />
          </div>
          <div>
            <h3 className="text-lg font-bold text-gray-900">Filtros de Pessoas</h3>
            <p className="text-sm text-gray-600">Refine a listagem de acordo com a necessidade</p>
          </div>
        </div>
        <button
          onClick={handleClear}
          className="px-3 py-1 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-all duration-200 font-medium"
        >
          <X className="w-4 h-4 mr-2 inline" />
          Limpar
        </button>
      </div>

      <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="md:col-span-2">
          <label className="block text-sm font-medium text-gray-700 mb-2">Buscar</label>
          <div className="relative">
            <input
              type="text"
              value={filters.search || ''}
              onChange={(e) => handleInputChange('search', e.target.value)}
              className="w-full px-3 py-2 pl-10 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all duration-200"
              placeholder="Buscar por nome, e-mail, telefone ou cargo..."
            />
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">Status</label>
          <select
            value={filters.ativo || 'todos'}
            onChange={(e) => handleInputChange('ativo', e.target.value as PessoaFilters['ativo'])}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-500 focus:border-transparent transition-all duration-200"
          >
            <option value="todos">Todos</option>
            <option value="sim">Ativos</option>
            <option value="nao">Inativos</option>
          </select>
        </div>

        <div className="md:col-span-3 flex justify-end">
          <button
            type="submit"
            className="px-4 py-2 text-white bg-brand-500 rounded-lg hover:bg-brand-600 transition-all duration-200 font-medium"
          >
            <Search className="w-4 h-4 mr-2 inline" />
            Buscar Pessoas
          </button>
        </div>
      </form>
    </div>
  )
}
